import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit, OnDestroy {

  $destroy = new Subject();

  isLinkValid = true;

  gender = "m";

  firstName = "";

  lastName = "";

  eMail = "";

  password = "";

  passwordRetype = "";

  secret = "";

  error = "";

  pwdMinLength: number;

  pwdPattern: string;

  pwdErrorMsg: string;

  passwordTextType: boolean = false;

  confirmPasswordTextType: boolean = false;

  constructor(
    private api : ApiService,
    private route : ActivatedRoute,
    private router : Router) { }

  ngOnInit() {
    this.pwdMinLength = 8;
    this.pwdPattern = "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}";
    this.pwdErrorMsg = "Das Passwort muss mindestens 8 Zeichen lang sein und 1 Großbuchstaben, 1 Kleinbuchstaben und 1 Sonderzeichen enthalten";

    var $paramsChanged = this.route.params;

    $paramsChanged.pipe(takeUntil(this.$destroy)).subscribe(params => {
      this.secret = params["secret"];

      this.api.get('register/' + this.secret).subscribe((d : any) => {
        this.isLinkValid = d.IsValid;
        this.eMail = d.EMail;
        this.firstName = d.FirstName,
        this.lastName = d.LastName
      },
      e => {
        this.isLinkValid = false;
      })
    });

    
  }

  ngOnDestroy() {
    this.$destroy.next();
  }

  submit() {

    this.error = '';

    if (!this.gender)
    {
      this.error = "Bitte geben Sie eine bevorzugte Anrede an";
      return;
    }

    if (!this.firstName)
    {
      this.error = "Bitte geben Sie Ihren Vornamen ein";
      return;
    }

    if (!this.lastName)
    {
      this.error = "Bitte geben Sie Ihren Nachnamen ein";
      return;
    }

    if (!this.eMail)
    {
      this.error = "Bitte geben Sie ein E-Mail-Adresse ein";
      return;
    }

    if (!this.password)
    {
      this.error = "Bitte geben Sie ein Passwort ein";
      return;
    }

    if (!this.passwordRetype)
    {
      this.error = "Bitte geben Sie die Wiederholung des Passworts ein";
      return;
    }

    if (this.password !== this.passwordRetype)
    {
      this.error = "Die Passwort-Eingaben stimmen nicht überein";
      return;
    }

    var args = {
      FirstName : this.firstName,
      LastName : this.lastName,
      EMail : this.eMail,
      Password : this.password,
      Gender: this.gender,
      Secret: this.secret
    }

    this.api.register(args).subscribe(
      (data: any) => {
        console.log(data);
        if (data.Succeeded) {          
            this.navigate();          
        }
        else {
          this.error = data.Error;
        }
      },
      error => {
        console.log(error);
        if (error.message)
          this.error = error.message;
        else
          this.error = "Ein Fehler ist aufgetreten";
      });
    
  }

  navigate() {
    this.router.navigateByUrl('/frame/dashboards');
  }

  toggleFieldTextType(controlName: string) {
    if (controlName == 'P') {
      this.passwordTextType = !this.passwordTextType;
    }
    if (controlName == 'COP') {
      this.confirmPasswordTextType = !this.confirmPasswordTextType;
    }
  }

}
